import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyCheckRoleSummaryReport } from './Pages';

export const DailyCheckRoleSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyCheckRoleSummaryReport} />
       
    </Fragment>
)